import { render, staticRenderFns } from "./invoice3.vue?vue&type=template&id=3b34c31e&scoped=true"
import script from "./invoice3.vue?vue&type=script&lang=js"
export * from "./invoice3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34c31e",
  null
  
)

export default component.exports